(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["testimonios-whatsapp"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-testimonios-wsp]').forEach(function (root) {
  var track = root.querySelector('[data-track]');
  if (!track) return;
  root.querySelectorAll('[data-dir]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slide = track.querySelector('.tw-testimonios__slide');
      var step = slide ? slide.offsetWidth + 14 : 280;
      track.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
